import { render, staticRenderFns } from "./Mplus.vue?vue&type=template&id=2dfeaf06&scoped=true&"
import script from "./Mplus.vue?vue&type=script&lang=js&"
export * from "./Mplus.vue?vue&type=script&lang=js&"
import style0 from "./Mplus.vue?vue&type=style&index=0&id=2dfeaf06&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2dfeaf06",
  null
  
)

export default component.exports